<script lang="ts">
import { defineComponent } from 'vue';
import Decimal from 'decimal.js-light';

export default defineComponent({
  name: 'bets-row-totals',
  computed: {
    totalPayout() {
      return new Decimal(this.totals?.paidOutAmount || 0).plus(
        new Decimal(this.totals?.refundAmount || 0)
      );
    },

    totalBalance() {
      return new Decimal(this.totalPayout).minus(this.totals?.stakeAmount || 0);
    },
  },
  props: ['totals'],
});
</script>

<template>
  <tr>
    <td colspan="5" class="!text-left !pl-5">ИТОГО</td>
    <td colspan="2" class="!text-right">
      Активные ставки<br/>
      $ <span class="text-yellow-500 font-mono">
        {{ parseFloat(totals.activeAmount || 0).toFixed(4) }}
      </span>
    </td>
    <td colspan="2" class="!text-right">
      Сумма ставок<br/>
      $ <span class="text-yellow-500 font-mono">
        {{ parseFloat(totals.stakeAmount || 0).toFixed(4) }}
      </span>
    </td>
    <td colspan="3" class="!text-right">
      Макс.выигрыш по открытым<br/>
      $ <span class="text-yellow-500 font-mono">
        {{ parseFloat(totals.maxOpenWin || 0).toFixed(4) }}
      </span>
    </td>
    <td colspan="2" class="!text-right">
      Сумма выплат<br/>
      $ <span class="text-yellow-500 font-mono">
        {{ totalPayout.toFixed(4) }}
      </span>
    </td>
    <td colspan="3" class="!text-right !text-lg">
      Баланс по ставкам:<br/>
      $ <span
        :class="{
        'font-mono': true,
        '!text-red-500': totalBalance.lessThan(0),
        '!text-green-500': totalBalance.greaterThanOrEqualTo(0),
      }"
      >
        {{ totalBalance.toFixed(2) }}
      </span>
    </td>
  </tr>
</template>

<style scoped lang="scss"></style>